import { render, staticRenderFns } from "./ToReceiveTable.vue?vue&type=template&id=670e8940&scoped=true&"
import script from "./ToReceiveTable.vue?vue&type=script&lang=js&"
export * from "./ToReceiveTable.vue?vue&type=script&lang=js&"
import style0 from "./ToReceiveTable.vue?vue&type=style&index=0&id=670e8940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e8940",
  null
  
)

export default component.exports